import React from 'react';
import zipcelx from 'zipcelx';

import { Button } from 'selfly-ui-react';

/**
 * Export data as excel sheet
 * 
 * @param {object} props 
 * @param {string} props.filename - Name of the exported excel file (without file extension)
 * @param {Array<object>} props.data - The data to be exported
 * @param {Array<object>} props.dataTableConfig - The column settings for the data. Identical to one used with dataTable
 */
export default function ExportButton(props) {

    function createExcelExport() {
        const headerRow = props.dataTableConfig.map(col => {
            return {
                value: col.header ? col.header : 'unknown',
                type: 'string',
            };
        });

        const dataRows = props.data.map(item => {
            return props.dataTableConfig.map(col => {
                const value =
                    item[col.key] === undefined
                        ? ''
                        : col.content !== undefined &&
                          typeof col.content === 'function'
                        ? col.content(item[col.key], item, col, true)
                        : item[col.key];

                if(typeof value !== "string" || typeof value !== "number") {
                    return {
                        type: 'string',
                        value: item[col.key] !== undefined ? item[col.key] : ''
                    };
                }

                return {
                    value: value,
                    type: 'string',
                };
            });
        });

        const allRows = [headerRow].concat(dataRows);

        const config = {
            filename: props.filename ? props.filename : 'export',
            sheet: {
                data: allRows,
            },
        };

        try {
            zipcelx(config);
        } catch (err) {
            console.error('Failed to create an excel output', err);
        }
    }

    const classNames = `${props.className} export-button`;

    return (
        <Button
            icon="file_download"
            onClick={createExcelExport}
            alt="Download as excel"
            className={classNames}
        >
            Excel
        </Button>
    );
}
